import React from 'react';

import BlockBuilder from '../../BlockBuilder';
import SectionContainer from '../SectionContainer';
import css from './SectionHomeImg.module.css';

const SectionHomeImg = props => {
  const {
    sectionId,
    className,
    blocks = [],
    appearance,
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      rootClassName={css.root}
      className={className}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasBlocks ? (
        <div className={css.twoColGrid}>
          <BlockBuilder
            ctaButtonClass={css.ctaButton}
            blocks={blocks}
            sectionId={sectionId}
            responsiveImageSizes="(max-width: 767px) 100vw, 600px"
            options={options}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionHomeImg;
